import BrandWorldNavBar from "../../components/navigation/BrandWorldNavBar"
import FilterContextProvider from "../../provider/FilterContextProvider"
import BikesCollectionContainer from "../../components/bikesCollection/BikesCollectionContainer"
import BrandInfoSection from "../../components/brandWorld/BrandInfoSection"
import React, {useContext, useEffect} from "react"
import BrandWorldHeaderSection from "../../components/brandWorld/BrandWorldHeaderSection"
import ResourcesSection from "../../components/brandWorld/ResourcesSection"
import DataContext from "../../context/DataContext"
import {useRouter} from "next/router"
import {filterUrl} from "../filter/FilterUrl"
import urlParams from "../../utility/UrlParams"
import {CollectionName} from "../../constants"

function BrandWorldContent({reviews}: { reviews: any[] }) {
	const {brandWorld} = useContext(DataContext)

	const router = useRouter()
	useEffect(() => {
		if (brandWorld?.categories) {
			router.replace(
				`${filterUrl(
					{[urlParams.categories]: brandWorld?.categories},
					urlParams.categories,
					brandWorld?.categories,
					CollectionName.BrandWorld,
					CollectionName.BrandWorld,
					brandWorld?.brandSlug
				)}`,
				null,
				{shallow: true}
			)
		}
	}, [brandWorld?.categories, router.asPath])
	return (
		<main
			className="position-relative">
			<BrandWorldNavBar />
			<BrandWorldHeaderSection />
			<div id="products-listing"
				style={{minHeight: "10rem"}}
				className="brand-world-bikes-container py-4 container-md">
				<FilterContextProvider>
					<BikesCollectionContainer productsCount={50} />
				</FilterContextProvider>
			</div>
			<BrandInfoSection />
			<ResourcesSection reviews={reviews} />
		</main>
	)
}

export default BrandWorldContent
